<td [class]="cx('outerCell')" [attr.colspan]="colspan()">
  <div [class]="cx('wrapper')">
    <table [class]="cx('table')">
      <ng-container *ngTemplateOutlet="body()" />
    </table>
  </div>
</td>
